<template>
    <app-modal unique="add-hospital" title="Add PCR Clinic / Hospital">
        <form @submit.prevent="confirmAddHospital">

            <div class="form-group form-row mb-1" :class="{'has-error': newHospitalErrors.code}">
                <label for="new-hospital-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Hospital Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-hospital-code" class="form-control form-control-xs"
                           placeholder="Type Hospital Code Here"
                           v-model="newHospital.code"
                    >
                    <span class="help-block" v-if="!!newHospitalErrors.code">
                      <small><strong>{{ newHospitalErrors.code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newHospitalErrors.name}">
                <label for="new-hospital-name" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Hospital Name:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="new-hospital-name" class="form-control form-control-xs" required
                           placeholder="Type Hospital Name Here"
                           v-model="newHospital.name"
                    >
                    <span class="help-block" v-if="!!newHospitalErrors.name">
                      <small><strong>{{ newHospitalErrors.name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newHospitalErrors.country_id}">
                <label for="new-hospital-country" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <select id="new-hospital-country" class="form-control form-control-xs input-group-append"
                            v-model="newHospital.country_id" required
                    >
                        <option :value="undefined">--- No Country ---</option>
                        <option v-for="countryKey in countryKeys"
                                :key="countryKey.id"
                                :value="countryKey.id"
                        >{{ countryKey.name }}</option>
                    </select>
                    <span class="help-block" v-if="!!newHospitalErrors.country_id">
                      <small><strong>{{ newHospitalErrors.country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': newHospitalErrors.crew_covid_test_country_id}">
                <label for="new-hospital-other-country" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Other Country:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <select id="new-hospital-other-country" class="form-control form-control-xs input-group-append"
                            v-model="newHospital.crew_covid_test_country_id" required
                    >
                        <option :value="undefined">--- No Country ---</option>
                        <option v-for="otherCountryKey in otherCountryKeys"
                                :key="otherCountryKey.id"
                                :value="otherCountryKey.id"
                        >{{ otherCountryKey.name }}</option>
                    </select>
                    <span class="help-block" v-if="!!newHospitalErrors.crew_covid_test_country_id">
                      <small><strong>{{ newHospitalErrors.crew_covid_test_country_id }}</strong></small>
                    </span>
                </div>
            </div>


            <hr />
            <div class="text-right">
                <button type="submit" class="btn btn-primary btn-sm btn-xs mr-3 font-weight-bolder" v-if="!guest">
                    <i class="fas fa-save"></i> Save
                </button>
            </div>
        </form>
    </app-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
    name: "AddHospital",

    components: { AppModal },

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    data() {
        return {
            newHospital: {},
            newHospitalErrors: {}
        }
    },

    methods: {
        ...mapActions([
            'addHospital'
        ]),

        async confirmAddHospital() {
            if(await this.confirmCreateAlert()) {
                let newHospital = await this.addHospital(this.newHospital);
                if(newHospital) {
                    if(newHospital.errors) {
                        this.newHospitalErrors = newHospital.errors;
                    } else {
                        this.successAlert('New Hospital Successfully Saved', 'CREATE');
                        document.getElementById('close-add-hospital').click();
                    }
                } else {
                    this.errorAlert('New Hospital Failed to Add', 'CREATE');
                }
            }
        }
    },

    computed: {
        ...mapGetters([
            'countryKeys',
            'otherCountryKeys'
        ])
    }
}
</script>

<style scoped>

</style>